<template>
  <van-dialog title="编辑" v-model="show" :show-cancel-button="true" cancel-button-text="取消" confirm-button-text="确定" type="danger" class-name="pc-dialog pc-gg-dialog" :before-close="handleSubmit">
    <div class="setting-component-container">
      <div class="column-item">
        <div class="title-item">用户昵称</div>
        <div class="input">
          <input v-model="nickname" type="text" placeholder="请输入昵称" />
        </div>
        <!-- eslint-disable -->
        <div class="input-tip">请设置2-24个字符，不包括@<>/等无效字符</div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  emits: ['success', 'close'],
  name: "SettingNicknameComponent",
  data() {
    return {
      show: false,
      nickname: '',
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  methods: {
    open() {
      this.show = true
      this.nickname = this.userInfo.Nickname
    },
    async handleSubmit(action, done) {
      if (action == 'cancel') {
        this.$emit('onClose')
        done()
        return
      }
      if (action == 'confirm') {
        const { nickname } = this
        if (nickname == '') {
          this.$toast('请输入昵称')
          done(false)
          return
        }
        var res = await this.$API.userInfo.post({
          Switch: 2,
          Nickname: nickname
        })
        if (res.error == 0) {
          this.$toast.success(res.info)
          this.show = false
          this.$emit('success')
          done()
        } else {
          this.$dialog.alert({
            type: 'danger',
            className: 'pc-dialog',
            title: '提示',
            message: res.info,
            confirmButtonText: '确定',
          })
          done(false)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.setting-component-container {
  padding: 0 15px;
}
.column-item {
  margin-bottom: 20px;
  overflow: hidden;
  .title-item {
    padding-left: 18px;
    position: relative;
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    font-weight: 500;
    color: #393942;
    margin-bottom: 15px;
    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      width: 3px;
      height: 20px;
      border-radius: 0 2px 2px 0;
      background-color: #5783fc;
    }
  }
  .input {
    padding: 0 15px;
    border-radius: 5px;
    background-color: #f7f7f7;
    height: 40px;
  }
  .input-tip {
    font-size: 12px;
    color: #a1a8b4;
    line-height: 18px;
  }
}
</style>